export enum UserType {
  NONE = 0,
  ADMIN = 1,
  NORMAL_SINGLE = 2,
  NORMAL_MULTIPLE = 3,
  SUPER_ADMIN = 4,
}
